import React from 'react';
import Button from 'monday-ui-react-core/dist/Button';
import { useTipseens } from '../../contexts/tipseen-context';

import './guidence-component.scss';
import { GUIDENCE_TIPSEEN } from '../../constants/tipseens';
import { ARTICLE_LINK } from '../../constants';

export default function GuidenceComponent() {
  const { syncTipseen } = useTipseens();

  const handleCreateButtonClicked = () => {
    syncTipseen(GUIDENCE_TIPSEEN);
  };

  const openArticle = () => {
    window.open(ARTICLE_LINK, '_blank');
  };

  return (
    <div className="guidence-component">
      <div className="content">
        <div className="image-wrapper">
          <img src="/assets/quote/quote.png" alt="" />
        </div>
        <div className="title">Create instant documents, easily.</div>
        <div className="subtitle">
          Transform your data into a professional
          <br /> quote or invoice in minutes.
        </div>
        <div className="create-button-wrapper">
          <Button size={Button.sizes.SMALL} onClick={handleCreateButtonClicked}>
            Create document
          </Button>
        </div>
        <div className="learn-more-button-wrapper">
          <Button size={Button.sizes.SMALL} onClick={openArticle} kind={Button.kinds.TERTIARY}>
            Learn more
          </Button>
        </div>
      </div>
    </div>
  );
}
